export default "/_next/static/aba557f23fdb5085631c26be59be997c.png";